import { BaseClient } from '~client/base-client';
import { ClientConfig } from '~client/client-config';
import { AdvertisementTrackingController } from '~client/controller/advertisement-tracking-controller';
import { AuctionController } from '~client/controller/auction-controller';
import { ClientGuestPurchaseController } from '~client/controller/client-guest-purchase-controller';
import { ClientUserController } from '~client/controller/client-user-controller';
import { ConfigurationController } from '~client/controller/configuration-controller';
import { CslUserController } from '~client/controller/csl-user-controller';
import { DrawController } from '~client/controller/draw-controller';
import { EventController } from '~client/controller/event-controller';
import { EventUserRefundController } from '~client/controller/event-user-refund-controller';
import { ExternalPaymentCallbackController } from '~client/controller/external-payment-callback-controller';
import { GeoDataController } from '~client/controller/geo-data-controller';
import { InventorySelectionController } from '~client/controller/inventory-selection-controller';
import { LiveConferenceUserController } from '~client/controller/live-conference-user-controller';
import { LocationController } from '~client/controller/location-controller';
import { MarketplaceController } from '~client/controller/marketplace-controller';
import { NewsletterController } from '~client/controller/newsletter-controller';
import { PaymentController } from '~client/controller/payment-controller';
import { PayoutController } from '~client/controller/payout-controller';
import { PromoterController } from '~client/controller/promoter-controller';
import { PromoterPurchaseController } from '~client/controller/promoter-purchase-controller';
import { PurchaseController } from '~client/controller/purchase-controller';
import { ReportingController } from '~client/controller/reporting-controller';
import { ResaleController } from '~client/controller/resale-controller';
import { TokenAssignmentController } from '~client/controller/token-assignment-controller';
import { UserActivityController } from '~client/controller/user-activity-controller';
import { UserLoginController } from '~client/controller/user-login-controller';
import { UserNotificationSettingsController } from '~client/controller/user-notification-settings-controller';
import { UserProfileController } from '~client/controller/user-profile-controller';
import { ClientGuestController } from '~client/controller/client-guest-controller';
import { ClientInventoryAvailabilityController } from '~client/controller/client-inventory-availability-controller';
import { EventStreamClientController } from '~client/controller/event-stream-client-controller';
import { LiveConferenceClientController } from '~client/controller/live-conference-client-controller';
import { EventUserController } from '~client/controller/event-user-controller';
import { VideoAnalyticsController } from '~client/controller/video-analytics-controller';

/*
 * Docs: https://api.dev.yoop.app/swagger-ui.html
 */
export class ApiClient extends BaseClient {
  advertisementTrackingController: AdvertisementTrackingController;
  auctionController: AuctionController;
  clientGuestPurchaseController: ClientGuestPurchaseController;
  clientUserController: ClientUserController;
  cslUserController: CslUserController;
  drawController: DrawController;
  purchaseController: PurchaseController;
  promoterController: PromoterController;
  promoterPurchaseController: PromoterPurchaseController;
  eventController: EventController;
  eventUserController: EventUserController;
  eventStreamClientController: EventStreamClientController;
  eventUserRefundController: EventUserRefundController;
  geoDataController: GeoDataController;
  inventorySelectionController: InventorySelectionController;
  liveConferenceClientController: LiveConferenceClientController;
  liveConferenceUserController: LiveConferenceUserController;
  marketplaceController: MarketplaceController;
  newsletterController: NewsletterController;
  paymentController: PaymentController;
  payoutController: PayoutController;
  reportingController: ReportingController;
  resaleController: ResaleController;
  tokenAssignment: TokenAssignmentController;
  userLoginController: UserLoginController;
  userProfileController: UserProfileController;
  userNotificationSettingsController: UserNotificationSettingsController;
  userActivityController: UserActivityController;
  locationController: LocationController;
  configurationController: ConfigurationController;
  clientGuestController: ClientGuestController;
  clientInventoryAvailabilityController: ClientInventoryAvailabilityController;
  externalPaymentCallbackController: ExternalPaymentCallbackController;
  videoAnalyticsController: VideoAnalyticsController;

  constructor(config: ClientConfig) {
    super(config);
    this.advertisementTrackingController = new AdvertisementTrackingController(
      this.api,
      this.config,
    );
    this.auctionController = new AuctionController(this.api, this.config);
    this.clientGuestPurchaseController = new ClientGuestPurchaseController(this.api, this.config);
    this.clientUserController = new ClientUserController(this.api, this.config);
    this.cslUserController = new CslUserController(this.api, this.config);
    this.drawController = new DrawController(this.api, this.config);
    this.purchaseController = new PurchaseController(this.api, this.config);
    this.promoterController = new PromoterController(this.api, this.config);
    this.promoterPurchaseController = new PromoterPurchaseController(this.api, this.config);
    this.eventController = new EventController(this.api, this.config);
    this.eventUserController = new EventUserController(this.api, this.config);
    this.eventStreamClientController = new EventStreamClientController(this.api, this.config);
    this.eventUserRefundController = new EventUserRefundController(this.api, this.config);
    this.geoDataController = new GeoDataController(this.api, this.config);
    this.inventorySelectionController = new InventorySelectionController(this.api, this.config);
    this.liveConferenceClientController = new LiveConferenceClientController(this.api, this.config);
    this.liveConferenceUserController = new LiveConferenceUserController(this.api, this.config);
    this.marketplaceController = new MarketplaceController(this.api, this.config);
    this.newsletterController = new NewsletterController(this.api, this.config);
    this.paymentController = new PaymentController(this.api, this.config);
    this.payoutController = new PayoutController(this.api, this.config);
    this.reportingController = new ReportingController(this.api, this.config);
    this.resaleController = new ResaleController(this.api, this.config);
    this.tokenAssignment = new TokenAssignmentController(this.api, this.config);
    this.userLoginController = new UserLoginController(this.api, this.config);
    this.userProfileController = new UserProfileController(this.api, this.config);
    this.userNotificationSettingsController = new UserNotificationSettingsController(
      this.api,
      this.config,
    );
    this.userActivityController = new UserActivityController(this.api, this.config);
    this.locationController = new LocationController(this.api, this.config);
    this.configurationController = new ConfigurationController(this.api, this.config);
    this.clientGuestController = new ClientGuestController(this.api, this.config);
    this.clientInventoryAvailabilityController = new ClientInventoryAvailabilityController(
      this.api,
      this.config,
    );
    this.externalPaymentCallbackController = new ExternalPaymentCallbackController(
      this.api,
      this.config,
    );
    this.videoAnalyticsController = new VideoAnalyticsController(this.api, this.config);
  }

  public setAdTrackingIdHeader(advertisementId: string): void {
    this.setHeader('Advertisement-Id', advertisementId);
  }

  public setAdTrackingDataHeader(advertisementData: string): void {
    this.setHeader('Advertisement-Data', advertisementData);
  }

  public setSessionIdHeader(sessionUuid: string): void {
    this.setHeader('Api-Client-SessionId', sessionUuid);
  }

  public setUnauthorizedCallback(callback: () => void): void {
    this.config.unauthorizedCallback = callback;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/client/api-client.ts